<script>
import appConfig from "@/app.config";

/**
 * Confirm-mail component
 */
export default {
   page: {
    title: "Confirm Mail",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {};
  },
  components: {},
  methods: {},
};
</script>

<template>
  <div class="account-pages my-5 pt-sm-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="text-center mb-5 text-muted">
            <router-link to="/" class="d-block auth-logo">
              <img
                src="@/assets/images/logo-dark.png"
                alt=""
                height="20"
                class="auth-logo-dark mx-auto"
              />
              <img
                src="@/assets/images/logo-light.png"
                alt=""
                height="20"
                class="auth-logo-light mx-auto"
              />
            </router-link>
<!--            <p class="mt-3">Responsive Bootstrap 5 Admin Dashboard</p>-->
          </div>
        </div>
      </div>
      <!-- end row -->
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6 col-xl-5">
          <div class="card">
            <div class="card-body">
              <div class="p-2">
                <div class="text-center">
                  <div class="avatar-md mx-auto">
                    <div class="avatar-title rounded-circle bg-light">
                      <i class="bx bx-mail-send h1 mb-0 text-primary"></i>
                    </div>
                  </div>
                  <div class="p-2 mt-4">
                    <h4>{{ lodash.upperFirst($t('verify_email.verification_success')) }}</h4>
                    <p class="text-muted" style="white-space: pre"
                    >{{ lodash.upperFirst($t('verify_email.verification_success_message')) }}</p>
                    <div class="mt-4">
                      <router-link to="/" class="btn btn-primary"
                        >{{ lodash.upperFirst($t('verify_email.back_to_home')) }}</router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-5 text-center">
            <p>
              © {{ new Date().getFullYear() }} Tirta Farm
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
